import { useMemo } from 'react'

import Cookies from 'js-cookie'
import { useSelector } from 'react-redux'

import { getFullName } from '../../../utils/entities/schoolSpeciality'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { OrderBy } from '../../../utils/constants'
import DataTable from '../../../Components/antd/Tables/DataTable/DataTable'

const SpecialitiesTable = ({ data, institution = null, loading, metadata, parameters, onParametersChange, onTriggerAction }) => {
  const t = useSelector(selectTranslate)

  const maxHeight = useMemo(() => `calc(100vh - ${Cookies.get('switch_user_id') ? '180px' : '139px'})`, [Cookies.get('switch_user_id')])
  const columns = useMemo(() => [
    {
      title: t('data_table.column_title.name'),
      orderBy: OrderBy.NAME,
      key: s => {
        const name = getFullName(s)
        const maxLength = !institution ? 50 : 30

        return name.length > maxLength ? `${name.slice(0, maxLength - 3)}...` : name
      },
      tooltip: getFullName
    },
    { title: t('data_table.column_title.comment'), orderBy: OrderBy.COMMENT, key: s => s.comment }
  ], [institution, t])

  return (
    <div style={{ height: maxHeight }}>
      <DataTable
        columns={columns}
        data={data}
        loading={loading}
        metadata={metadata}
        parameters={parameters}
        onParametersChange={onParametersChange}
      />
    </div>
  )
}

export default SpecialitiesTable
